



























































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { CreateElement } from 'vue';
import Program from '@/models/Program';
import get from 'lodash/get';
import Address from '@/models/Address';
import compact from 'lodash/compact';
import { formatProgramTaxSystem } from '@/data/programs';
import { getTaxSystemColor, getTaxSystemValue } from '@/data/taxSystems';
import Company from '@/models/Company';
import moment from 'moment';
import Secret from '@/components/common/Secret.vue';
import axios from 'axios';
import AuthModule from "@/store/AuthModule";



// ------------------------------------------------------------------
// Define the keys for our table columns
// ------------------------------------------------------------------
const keys = [
  [
    'promoter',
    'tax_system',
    'valeur_nue_pro_percent',
    'duree_usufruit',
    'bail_dates',
    'bail_duration',
    'date_fin_bail',
    'taxe_fonciere',
    'charges_copro',
    'zone',
    'manager_operator',
    'nb_total_lots',
    'lowest_price',
    'highest_price',
    'average_price_per_square_meter',
    'url',
    'promoter_site_url',
    'is_boost_prescriber',
    'is_boost_customer',
    'seller_infos'
  ],
  [
    'code',
    'duty_free_fee',
    'date_building_permit_purged',
    'date_actability',
    'date_start_building',
    'date_end_building',
    'date_delivery'
  ]
];

// ------------------------------------------------------------------
// Define the labels (or renderers) for each key.
// ------------------------------------------------------------------
const programKeys: Record<
  string,
  string | { render: (h: CreateElement, context: any) => any }
> = {
  promoter: 'Promoteur',
  tax_system: 'Fiscalité',
  zone: "Zonage Pinel/Ptz",
  manager_operator: 'Gestionnaire/Exploitant',
  nb_total_lots: 'Nb total lot Prog',
  valeur_nue_pro_percent: 'Valeur Nue Pro',
  duree_usufruit: 'Durée d\'usufruit (années)',
  date_fin_bail: 'Fin du bail',
  taxe_fonciere: 'Taxe Foncière annuelle',
  charges_copro: 'Charges Copro annuelles',
  lowest_price: 'Prix le plus bas',
  highest_price: 'Prix le plus haut',
  average_price_per_square_meter: 'Prix/m²',
  url: 'Lien vers Visite 3D/Vidéo Progs.',
  code: 'Code',
  date_building_permit_purged: 'PC purgé',
  date_actability: 'Actable',
  date_start_building: 'Démarrage des travaux',
  date_end_building: 'Fin des travaux',
  date_delivery: 'Livraison',
  duty_free_fee: {
    render: (h: CreateElement, context: any) => {
      return h(
        'div',
        { class: 'flex items-center' },
        [
          h('span', 'Honoraires HT/TTC'),
          h(
            'div',
            {
              style: { display: 'inline-block', cursor: 'pointer' },
              on: {
                click: (e: MouseEvent) => {
                  e.stopPropagation();
                  // Emit the event from the parent ($root)
                  context.parent.$root.$emit('open-hono-modal');
                }
              }
            },
            [
              h('vs-icon', {
                props: {
                  icon: 'error',
                  class: 'ml-2 text-primary'
                },
                style: {
                  color: '#891A2B', // Remplacez par la couleur souhaitée
                  marginLeft: '8px'
                }
              })
            ]
          )
        ]
      );
    }
  },
  promoter_site_url: 'Lien du site du promoteur',
  promoter_administrative_comment: 'Commentaires Administratif',
  is_boost_prescriber: 'Boost hono.',
  is_boost_customer: 'Avant. client',
  seller_infos: 'Infos vendeur',
  bail_dates: 'Début/Fin du bail',
  bail_duration: 'Durée du bail'
};

// ------------------------------------------------------------------
// Define a mapping for value formatting.
// ------------------------------------------------------------------
const lotValues = {
  promoter: promoter,
  tax_system: formatProgramTaxSystem,
  lowest_price: euro,
  highest_price: euro,
  taxe_fonciere: euro,
  charges_copro: euro,
  valeur_nue_pro_percent: percent,
  duree_usufruit: years,
  average_price_per_square_meter: euro,
  address: address,
  url: url,
  code: code,
  date_building_permit_purged: date,
  date_actability: date,
  date_start_building: date,
  date_end_building: date,
  date_delivery: date,
  date_fin_bail: date
};

// ------------------------------------------------------------------
// Helper functions for formatting
// ------------------------------------------------------------------
function euro(value: number) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  }).format(value);
}

function code(value: string) {
  return value;
}

function years(value: string) {
  return value + ' ans';
}

function percent(value: string) {
  return value + ' %';
}

function url(value: string) {
  if (!value) {
    return '';
  }
  return `<a class="hover:underline" target="_blank" href="${value}">${value}</a>`;
}

function date(value: string) {
  return moment(value).format('L');
}

function address(address: Address) {
  const _street = [address.street, address.street2];
  const street = compact(_street);
  const streetStr = street.join(', ');
  return `${streetStr}, ${address.postal_code} ${address.city}`;
}


function promoter(promoterObj: Company) {
  if (!promoterObj) {
    return '';
  }
  return promoterObj.name;
}

function formatProgramKey(value: string) {
  const key = get(programKeys, value);
  return typeof key === 'object'
    ? key.render(Vue.prototype.$createElement, {})
    : key;
}

//   // Formatter les dates début et fin en une seule ligne :
// function bail_dates(_: any, program: Program) {
//   if (!program.date_debut_bail || !program.date_fin_bail) return 'NC';
//   return `${moment(program.date_debut_bail).format('DD/MM/YYYY')} → ${moment(program.date_fin_bail).format('DD/MM/YYYY')}`;
// }

// // Formatter la durée du bail en années et mois proprement :
// function bail_duration(value: number) {
//   if (!value) return 'NC';
  
//   const years = Math.floor(value);
//   const months = Math.round((value - years) * 12);
//   let durationStr = `${years} an${years > 1 ? 's' : ''}`;
//   if (months > 0) {
//     durationStr += ` ${months} mois`;
//   }
//   return durationStr;
// }

// ------------------------------------------------------------------
// Component definition
// ------------------------------------------------------------------
@Component({
  data: () => ({
    keys
  }),
  filters: {
    formatProgramKey,
    getTaxSystemValue
  },
  components: {
    Secret
  }
})
export default class ProgramInfosPrescriber extends Vue {

  @Prop() program!: Program;
  @Prop({ default: false }) privateMode!: boolean;



   // ← Nouveaux champs pour Hono
          withHono: boolean = false;
          commissionRate: number = 0;

          created() {
            this.loadCommissionRateFromAuth();
          }


          private loadCommissionRateFromAuth() {
            const raw = localStorage.getItem('auth');
            if (!raw) return;
            try {
              const auth = JSON.parse(raw);
              const subs = Array.isArray(auth.subscriptions) ? auth.subscriptions : [];
              if (!subs.length) return;
              const last = subs[subs.length - 1];
             
              console.log(
                '[Auth] last.with_hono =', last.with_hono,
                ', last.commission_rate =', last.commission_rate
              );

              this.withHono = !!last.with_hono;
              this.commissionRate = typeof last.commission_rate === 'string'
                ? parseFloat(last.commission_rate)
                : Number(last.commission_rate) || 0;

              console.log(
                '[Auth] this.withHono =', this.withHono,
                ', this.commissionRate =', this.commissionRate
              );
            } catch (e) {
              console.error('[Auth] JSON.parse error:', e);
            }
          }

          get displayDutyFreeFee(): string {
              const base = Number(this.program.duty_free_fee) || 0;

              // Si la commission est positive et les honoraires sont définis
              if (this.withHono && this.commissionRate > 0) {
                  const diff = Math.max(0, Math.round((base - this.commissionRate) * 100) / 100);
                  return diff > 0 ? `${diff}%` : 'NC'; // Afficher 'NC' si la différence est <= 0
              }

              // Sinon, afficher les honoraires bruts si supérieurs à zéro, sinon 'NC'
              return base > 0 ? `${base}%` : 'NC';
          }



          



  // Returns a functional component to render the key label.
  getKeyComponent(key: string) {
    const value = programKeys[key];
    if (typeof value === 'object' && value.render) {
      return {
        functional: true,
        render: value.render
      };
    } else {
      return {
        functional: true,
        render(h: any) {
          return h('span', value);
        }
      };
    }
  }


  getPromoterDisplay(promoterObj: Company): string {
  if (!promoterObj) {
    return '';
  }
  return this.privateMode ?  promoterObj.name : `Promoteur - N° ${promoterObj.id}`;
}


  calculateRemainingBail(endDate: string): string {
    if (!endDate) return 'NC';

    const today = moment();
    const end = moment(endDate, "YYYY-MM-DD");

    if (end.isBefore(today)) {
        return 'Tacite reconduction - 12 mois';
    }

    const totalMonths = end.diff(today, 'months');
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;

    if (years > 0 && months > 0) {
        return `${years} an${years > 1 ? 's' : ''} ${months} mois`;
    } else if (years > 0) {
        return `${years} an${years > 1 ? 's' : ''}`;
    } else {
        return `${months} mois`;
    }
}


formatProgramValue(value: any, key: string) {
  if (key === 'bail_duration') {
    console.log('Valeur brute bail_duration :', this.program.bail_duration);
    const val = Number(this.program.bail_duration);
    console.log('Valeur convertie bail_duration :', val);
    const hasBailDuration = !isNaN(val) && val > 0;
    const hasFinalDate = this.program.date_fin_bail ? true : false;
    // Si on a la date de fin, on calcule toujours le temps restant
    const remaining = hasFinalDate ? this.calculateRemainingBail(this.program.date_fin_bail) : null;

    // 1. On a la durée totale et la durée restante
    if (hasBailDuration && remaining && remaining !== 'NC') {
      const years = Math.floor(val);
      const months = Math.round((val - years) * 12);
      let durationStr = `${years} an${years > 1 ? 's' : ''}`;
      if (months > 0) {
        durationStr += ` ${months} mois`;
      }
      return `${durationStr} (<strong>Restant : ${remaining}</strong>)`;
    }
    // 2. On a seulement la durée restante (on n'a que la date de fin)
    else if (!hasBailDuration && remaining && remaining !== 'NC') {
      return `<strong>Restant : ${remaining}</strong>`;
    }
    // 3. On n'a ni durée totale ni date de fin valides
    else {
      return 'NC';
    }
  }

  if (key === 'promoter') {
    return this.getPromoterDisplay(value);
  }


  // Laisse le reste inchangé
  if (key === 'bail_dates') {
    const debut = this.program.date_debut_bail ? moment(this.program.date_debut_bail).format('DD/MM/YYYY') : 'NC';
    const fin = this.program.date_fin_bail ? moment(this.program.date_fin_bail).format('DD/MM/YYYY') : 'NC';
    if (debut === 'NC' && fin === 'NC') return 'NC';
    return `${debut} → ${fin}`;
  }

  if (!value) {
    if (key === 'promoter_site_url' && this.program.promoter) {
      return this.program.promoter.public_site_url;
    } else if (key === 'promoter_administrative_comment' && this.program.promoter) {
      return this.program.promoter.administrative_comment;
    } else if (key === 'duty_free_fee') {
      // Si duty_free_fee est défini et < 12, afficher le pourcentage
      if (this.program.duty_free_fee != null && this.program.duty_free_fee < 12) {
        return `${this.program.duty_free_fee}%`;
      }
      // Si duty_free_fee est undefined et dff_comments existe, afficher "Infos complémentaires"
      else if (this.program.duty_free_fee === undefined && this.program.dff_comments != null) {
        return 'Infos complémentaires';
      }
      // Dans tous les autres cas (y compris quand les deux sont null/undefined), afficher NC
      return 'NC';
    } else if (key === 'zone' && this.program.address) {
      return `${this.program.address.zone}`;
    } else {
      return '';
    }
  }

  const fn = get(lotValues, key, (val: string) => val);
  return fn(value);
}







  get isRestricted() {
    return AuthModule.isRestricted;
  }

  isManageable() {
    if (this.program && this.program.tax_system) {
      if (
        this.program.tax_system.includes('LMNP VEFA Divers') ||
        this.program.tax_system.includes('LMNP Étudiant') ||
        this.program.tax_system.includes('LMNP Senior') ||
        this.program.tax_system.includes('LMNP Tourisme') ||
        this.program.tax_system.includes('LMNP EHPAD') ||
        this.program.tax_system.includes('LMNP CRT') ||
        this.program.tax_system.includes('LMNP Coliving') ||
        this.program.tax_system.includes('LMNP Colocation') ||
        this.program.tax_system.includes('CIIC Corse') ||
        this.program.tax_system.includes('Revente LMNP EHPAD') ||
        this.program.tax_system.includes('Revente LMNP Rés') ||
        this.program.tax_system.includes('Revente LMNP Étudiant') ||
        this.program.tax_system.includes('Revente LMNP Sénior') ||
        this.program.tax_system.includes('Revente LMNP Tourisme') ||
        this.program.tax_system.includes('Revente fin défiscalisation')
      ) {
        return true;
      }
    }
    return false;
  }

  isLMNP() {
    if (this.program && this.program.tax_system) {
      if (
        this.program.tax_system.includes('LMNP VEFA Divers') ||
        this.program.tax_system.includes('LMNP Étudiant') ||
        this.program.tax_system.includes('LMNP Senior') ||
        this.program.tax_system.includes('LMNP Tourisme') ||
        this.program.tax_system.includes('LMNP EHPAD') ||
        this.program.tax_system.includes('LMNP Coliving') ||
        this.program.tax_system.includes('LMNP Colocation') ||
        this.program.tax_system.includes('LMNP CRT') ||
        this.program.tax_system.includes('CIIC Corse')
      ) {
        return true;
      }
    }
    return false;
  }

  isRevente() {
  if (this.program && this.program.tax_system) {
    if (
      this.program.tax_system.includes('Revente LMNP Divers') ||
      this.program.tax_system.includes('Revente LMNP EHPAD') ||
      this.program.tax_system.includes('Revente LMNP Rés') ||
      this.program.tax_system.includes('Revente LMNP Étudiant') ||
      this.program.tax_system.includes('Revente LMNP Sénior') ||
      this.program.tax_system.includes('Revente LMNP Tourisme') ||
      this.program.tax_system.includes('Revente fin défiscalisation')
    ) {
      return true;
    }
  }
  return false;
}





  showInfos(value: any, key: string) {
    if (['bail_dates', 'bail_duration'].includes(key)) {
      return this.isRevente();  // Toujours afficher les lignes pour reventes (même si "NC")
    }

    if (key === 'duty_free_fee') {
    return true;
    }

    value = this.formatProgramValue(value, key);
    const condition = value !== '' && value !== 0 && value !== undefined && value !== 'NC';

    if (key === 'is_boost_customer') {
      return (
        this.program.is_boost_customer &&
        this.program.boost_comment_customer &&
        this.program.boost_due_date_customer &&
        moment().isBefore(this.program.boost_due_date_customer)
      );
    }
    
    if (key === 'is_boost_prescriber') {
      return (
        this.program.is_boost_prescriber &&
        this.program.boost_comment_prescriber &&
        this.program.boost_due_date_prescriber &&
        moment().isBefore(this.program.boost_due_date_prescriber)
      );
    }
    
    if (key === 'manager_operator' && !this.isManageable()) {
      return false;
    }
    
    if (
      ['date_fin_bail', 'taxe_fonciere', 'charges_copro'].includes(key) &&
      !this.isLMNP()
    ) {
      return false;
    }

    return condition;
  }


}
